import Link from "next/link";
import React from "react";

const FooterMenu = ({ dataFooter }) => {
  const menuFirst = dataFooter?.data[0];
  const menuSecond = dataFooter?.data.slice(1);

  return (
    <div className="flex flex-col lg:col-span-3">
      <div className="flex flex-col mb-12">
        <div>
          <strong className="block mb-4 text-sm font-medium leading-normal text-themeBlack">
            {menuFirst?.name}
          </strong>
          <div className="flex flex-wrap gap-5">
            {menuFirst?.items?.map((link) => (
              <Link
                title={link?.title}
                key={link.id}
                href={link?.url}
                prefetch={false}
                className="text-sm font-normal leading-normal text-opacity-50 transition-all duration-200 ease-in-out text-themeBlack hover:text-opacity-100 hover:underline"
              >
                {link?.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="flex sm:flex-nowrap flex-wrap lg:gap-[68px] sm:gap-8 ">
        {menuSecond?.map((list) => (
          <div
            key={list?.id}
            className="flex flex-col w-1/2 mb-4 sm:w-1/4 sm:mb-0"
          >
            <strong className="mb-6 text-sm font-medium leading-normal text-themeBlack">
              {list?.name}
            </strong>
            <div className="flex flex-col gap-[14px]">
              {list.items.map((item) => (
                <Link
                  key={item?.id}
                  href={item?.url}
                  title={item?.title}
                  prefetch={false}
                  className={`text-themeBlack text-opacity-50 text-size-13 font-normal leading-normal transition-all ease-in-out duration-200 hover:text-opacity-100 hover:underline ${
                    item?.name === "Yorumlar" ||
                    item?.name === "Nasıl Kiralarım?"
                      ? "font-medium text-sm !text-opacity-100"
                      : ""
                  }`}
                >
                  {item?.name}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FooterMenu;
